<template>
  <div class="colofon">
    <Lintje class="menu" :kaart="false" :minimap="minimap"/>
    <div class="vrij">Vrij!</div>
    <div class="stempel">
      <img alt="Vrij" src="../assets/stempel.png">
    </div>
    <div class="contentblock">
      <div class="terug" @click="goBack">{{ bron }}</div>
      <div class="textblock">
        <h2>Colofon</h2>
        <h3>Realisatie</h3>
        <p>
          Deze applicatie is een onderdeel van de website <a href="http://75jaarvrij.nl">75jaarvrij.nl</a>. De applicatie is gemaakt door <a href="https://webmapper.net" title="What the map can be">Webmapper</a> in opdracht van het <a
            href="www.defensie.nl/nimh"
          >Nederlands Instituut voor Militaire Historie</a> (<abbr title="Nederlands Instituut voor Militaire Historie">NIMH</abbr>). Het <abbr title="Nederlands Instituut voor Militaire Historie">NIMH</abbr> in Den Haag is een gespecialiseerd kennis- en onderzoekscentrum op het gebied van de Nederlandse militaire geschiedenis. Het instituut publiceert wetenschappelijke studies, verzorgt onderwijs aan militaire opleidingsinstituten en universiteiten, en maakt zijn verworven kennis en audiovisueel bezit toegankelijk voor een breed publiek.
        </p>
        <p>Aan de productie van deze kaartapplicatie werkten de volgende partners mee:</p>
        <table>
          <tr style="height:190px;">
            <td>
              <img alt="Logo Dienst Geografie" src="/img/logo-dgeo.png">
            </td>
            <td></td>
            <td>Dienst Geografie, <br/>Commando Landstrijdkrachten<br />'t Harde</td>
          </tr>
          <tr style="height:190px;">
            <td>
              <img alt="Logo Nationaal Comité 4 en 5 mei" src="/img/logo-4-5-mei.png">
            </td>
            <td></td>
            <td><a href="https://www.4en5mei.nl/" target="_blank">Nationaal Comité 4 en 5 mei</a><br />Amsterdam</td>
          </tr>
          <tr style="height:190px;">
            <td>
              <img alt="Logo Oorlogsgravenstichting" src="/img/logo-ogs.png">
            </td>
            <td></td>
            <td><a href="https://www.oorlogsgravenstichting.nl/" target="_blank">Oorlogsgravenstichting</a><br />Den Haag </td>
          </tr>
          <tr style="height:190px;">
            <td>
              <img alt="Logo Webmapper" src="/img/logo-webmapper.png">
            </td>
            <td></td>
            <td><a href="https://webmapper.net/" target="_blank" title="What the map can be">Webmapper</a><br />Utrecht</td>
          </tr>
        </table>

        <h3>Disclaimer</h3>
        <p>Het <abbr title="Nederlands Instituut voor Militaire Historie">NIMH</abbr> besteedt veel aandacht en zorg aan de informatie in de kaartapplicatie. Toch kan het voorkomen, dat deze onjuistheden en onvolkomenheden bevat. Het <abbr title="Nederlands Instituut voor Militaire Historie">NIMH</abbr> aanvaardt geen aansprakelijkheid, verplichtingen of verantwoordelijkheid voor enige schade ten gevolge van het gebruik of verspreiden van informatie in de kaartapplicatie of als gevolg van technische gebreken.</p>
        <p>Het <abbr title="Nederlands Instituut voor Militaire Historie">NIMH</abbr> heeft getracht alle rechthebbenden van het fotomateriaal te achterhalen. Mochten personen of instanties desondanks van mening zijn dat fotorechten niet zijn gehonoreerd, dan kunnen zij zich wenden tot het instituut.</p>
        <h3>Copyright</h3>
        <p>Tenzij anders is vermeld, is op de inhoud van deze website de <a href="https://creativecommons.org/publicdomain/zero/1.0/deed.nl">Creative Commons zero-verklaring</a> (CC0) van toepassing. Dit houdt in dat iedere vorm van hergebruik van de inhoud van deze site is toegestaan, tenzij bij of in een bepaald onderdeel (bijvoorbeeld een foto of een document) staat aangegeven, dat op dat onderdeel een auteursrechtelijke uitzondering van toepassing is.</p>
        <p>Bij hergebruik van de inhoud van deze website is naamsvermelding niet verplicht. Het <abbr title="Nederlands Instituut voor Militaire Historie">NIMH</abbr> stelt er wel prijs op als bij beeldmateriaal (foto en video) de naam 'Nederlands Instituut voor Militaire Historie' als bron wordt vermeld (tenzij anders aangegeven). Bij het citeren van de inhoud mag niet de indruk worden gewekt dat het ministerie van Defensie zonder meer de strekking van het afgeleide werk onderschrijft.</p>

        <p>De volgende rechten worden door de Creative Commons zero-verklaring niet gewijzigd en blijven dus van kracht:</p>
        <ul>
          <li>Octrooirechten en merkrechten.</li>
          <li>Rechten van anderen, ofwel op onderdelen van deze website, dan wel op de wijze waarop de website wordt gebruikt, zoals het portretrecht of privacyrecht.</li>
        </ul>
        <h3>Privacy en cookies, toegankelijkheid</h3>
        <p>Voor deze onderwerpen wordt verwezen naar <a href="http://75jaarvrij.nl">75jaarvrij.nl</a></p>
      </div>
    </div>
  </div>
</template>
<style scoped>
abbr[title] {
  text-decoration: none;
  border: none;
}
.colofon {
  background-image: url("../assets/colofon.jpg");
  background-position: center;
  background-size: cover;
  width: 100vw;
  height: 100vh;
}
.vrij {
  font-family: "BornReady";
  color: #f18e05;
  font-size: 80px;
  line-height: 140px;
  margin-left: 20px;
  margin-top: 20px;
  position: fixed;
  z-index: 10;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.contentblock {
  margin-right: 20px;
  padding-top: 110px;
  display: flex;
  flex-direction: column;
  position: absolute;
  align-items: flex-end;

  max-height: calc(100vh - 110px)
}
.textblock {
  background: #f0eeea;
  opacity: 0.9;
  z-index: 1;
  overflow-y:auto;
  padding-top: 70px;
  padding-left: 40px;
  padding-right: 20px;
  padding-bottom: 70px;
}
.terug {
  background: #7897b5;
  font-family: "RijksoverheidSansText";
  font-size: 24px;
  line-height: 40px;
  padding-left: 20px;
  padding-right: 20px;
  color: #f0eeea;
  cursor: pointer;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
  z-index: 10;
  transition: transform 50ms ease-in-out, opacity 50ms ease-in-out ;
}
.terug:hover {
  transform: translate(1px,1px);
  opacity: 0.9;
}
.terug:active {
  transform: none;
}
.textblock h2 {
  margin: 0px;
  font-family: "RijksoverheidSansText";
  font-size: 36px;
  line-height: 38px;

  /* identical to box height */

  color: #34352d;
}
.textblock p {
  font-family: "RijksoverheidSansText";
}
.textblock h3 {
  margin-bottom: 0px;
  font-family: "RijksoverheidSansText";
  font-size: 24px;
}
.menu {
  right: 120px;
  position: fixed;
  z-index: 10002;
}
.stempel {
    position: fixed;
    top: 20px;
    left: 147px;
  }
@media (min-width: 768px) {
  .menu {
    right: 145px;
  }
  .vrij {
    font-size: 120px;
    line-height: 180px;
    margin-left: 40px;
    margin-top: 40px;
  }
  .contentblock {
    margin-right: 100px;
    padding-top: 180px;

  max-height: calc(100vh - 180px)
  }
  .stempel {
    position: fixed;
    top: 60px;
    left: 237px;
  }

}
</style>

<script>
/**
  De view voor de colofon
 */
import Lintje from "../components/Lintje.vue";

export default {
  name: "Colofon",
  data: function() {
    return {
      bron: "Terug naar het verhaal",
      minimap: false
    };
  },
  components: {
    Lintje
  },
  methods: {
    goBack: function() {
      let params = this.$route.params;
      let name = params.source ? params.source==="colofon"?"verhaal":params.source : "verhaal";
      this.$router.push({ name: name, params: params });
    }
  },
  mounted() {
    let params = this.$route.params;
    if (params.source) {
      this.bron =
        params.source === "kaart"
          ? "Terug naar de kaart"
          : "Terug naar het verhaal";
    }
  }
};
</script>